import 'jquery.cookie';
import { ExWindow } from '@ve/types';

declare let window: ExWindow;
declare let $: {
    cookie(payload: string): string | undefined
};

const getABTestValue = () => ({
    platform: window.appConfig.isMobileDomain ? 'mobile' : 'desktop',
    get ab_identity() {
        return $.cookie(`ab_version_${this.platform}`);
    },
    get ab_identity_value() {
        return $.cookie(`ab_enabled_${this.platform}`);
    },
});

export default getABTestValue;
